import { EnvelopeIcon } from "@heroicons/react/24/outline";
import SectionTitle from "common/components/SectionTitle/SectionTitle";
import ProfileAvatar from "components/ProfileAvatar/ProfileAvatar";
import ProfileBadges from "components/ProfileBadges/ProfileBadges";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { Profile } from "types/Profile";

function ProfileCard({
  profile,
  title = "Profile",
  noTitle = false,
  onClick: handleClick = null,
  userEmail = null,
}: {
  profile: Profile;
  title?: string;
  noTitle?: boolean;
  onClick?: null | (() => void);
  userEmail?: string | null;
}) {
  return (
    <>
      {!noTitle && (
        <SectionTitle
          title={title}
          icon="UserIcon"
          className="text-secondary"
        />
      )}
      <div
        className={`responsive-flex flex-row gap-6 p-1 overflow-hidden ${
          handleClick
            ? "cursor-pointer border-white hover:border-slate-200 hover:bg-slate-50 border rounded-md"
            : ""
        }`}
        onClick={() => {
          if (handleClick) {
            handleClick();
          }
        }}
      >
        <ProfileAvatar profile={profile} growOnSmallDevice={false} />
        <div className="grid flex-1">
          <div className="flex flex-row justify-between flex-wrap items-center flex-1">
            <div className="font-bold text-xl">{profile?.username}</div>
            <ProfileBadges profile={profile} classname="self-justify-end" />
          </div>
          <div className="flex flex-row justify-start flex-wrap items-center flex-1 gap-4">
            <div className="font-bold text-md">
              {profile?.firstname} {profile?.lastname}
            </div>
          </div>
          {profile?.isCompany && (
            <div className="flex items-center gap-1 text-sm">
              <HiOutlineBuildingOffice2 className="w-4 h-4" />
              <span className="text-md font-bold">{profile?.companyName}</span>
            </div>
          )}
          {userEmail && (
            <div className="flex items-center gap-1 text-sm">
              <EnvelopeIcon className="w-4 h-4" />
              <span className="text-md font-bold">{userEmail}</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ProfileCard;
